module.exports = __webpack_public_path__ + "img/ebis.3ad34c4e.png";